import { HighchartsReact } from 'highcharts-react-official';
import Highcharts from 'highcharts';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';



type Props = {
    data: any[];
    height?: number;
    innerSize?: string;
}
const PieChart = (props: Props) => {
    const { t } = useTranslation();
    const chartRef = useRef(null);
    const mapOption = useMemo(() => {
        return {
            chart: {
                type: 'pie',
            },
            title: {
                text: '',
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                pie: {
                    size: '100%',
                    ...(props.innerSize && {
                        innerSize: props.innerSize
                    }),
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: true,
                    alignColumns: false,

                }
            },
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                // itemMarginTop: 10,
                itemMarginBottom: 10,
                labelFormat: "{name} &nbsp; {percentage:.2f} %",
                shadow: true,
                itemStyle: {
                    fontSize: '14px',
                    fontFamily: 'Prompt',
                    // color: '#333',
                    // fontWeight: 'bold',
                },
            },
            series: [{
                name: t('จำนวน'),
                colorByPoint: true,
                data: props.data
            }],
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 400
                    },
                    chartOptions: {
                        title: {
                            x: 0
                        },
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'horizontal'
                        },
                        pane: {
                            size: '70%'
                        }
                    }
                }]
            }
        }
    }, [props.data, t])
    return (
        <div style={{
            width: '100%'
        }}>
            <HighchartsReact
                containerProps={{ style: { width: "100%", height: props.height, padding: 0, margin: '0' } }}
                constructorType={'chart'}
                highcharts={Highcharts}
                options={mapOption}
                ref={chartRef}
            />
        </div>
    )
}

export default PieChart